/* global Vue, CardSlider, SINGLE_OFFER */

import OfferSliderMultiple from './OfferSliderMultiple'

export default {
  name: 'RecommendedOffers',
  components: { OfferSliderMultiple },
  template: `
  <div class="special-offers__recomendations bg-beige-50 section-padding section-margin-small-top" v-if="recommendedOffers.length > 0">
    <div class="container">
      <div class="section-heading">
        <div class="grid no-row-gap">
          <div class="section-heading__left col-12 col-xs-10 col-sm-8 col-md-7 col-lg-6 col-xl-5 offset-xl-1 col-xxl-4 offset-xxl-2">
            <h2 class="h1">{{ $t('offers.recommendedOffers') }}</h2>
              <hr style="opacity: 0.35; width: 1598px;">
          </div>
        </div>
      </div>
    </div>
    <div class="card-slider" :class="{
      'no-padding-bottom': offers.length < 3,
      'card-slider--no-slider': offers.length < 3,
    }" ref="sliderRef">
      <div class="container container--fluid" :class="{ 'grid': offers.length == 2 }">
        <OfferSliderMultiple :offers="recommendedOffers" buttonText="bookNow" :extraClasses="extraClasses" />
      </div>
    </div>
  </div>
  `,
  props: { offers: Array },
  setup (props) {
    const sliderRef = Vue.ref(null)
    const { offers } = Vue.toRefs(props)
    const { properties, destinations } = SINGLE_OFFER

    function compareByList (a, b, list) {
      const scoreA = a.filter(value => list.includes(value)).length
      const scoreB = b.filter(value => list.includes(value)).length
      const unmatchedA = a.length + list.length - scoreA
      const unmatchedB = b.length + list.length - scoreB
      if (scoreA > 0 || scoreB > 0) {
        if (scoreA - unmatchedA / 100 > scoreB - unmatchedB / 100) {
          return -1
        }
        if (scoreA - unmatchedA / 100 < scoreB - unmatchedB / 100) {
          return 1
        }
      }
      return 0
    }

    function compareOffers (a, b) {
      const compareByProperties = compareByList(a.properties, b.properties, properties)
      if (compareByProperties !== 0) {
        return compareByProperties
      }
      const compareByDestinations = compareByList(a.destinations, b.destinations, destinations)
      if (compareByDestinations !== 0) {
        return compareByDestinations
      }
      return 0
    }

    const recommendedOffers = Vue.computed(() => offers.value ? offers.value.sort(compareOffers).slice(0, 3) : []) // put logic here
    const extraClasses = Vue.computed(() => recommendedOffers.value.length === 2 ? ['width-auto-sm-down'] : [])

    setTimeout(() => {
      CardSlider(sliderRef.value)
    }, 1)

    return {
      recommendedOffers,
      extraClasses,
      sliderRef,
    }
  },
}
